import React from "react";
import { Card, Tabs } from "antd";
import CONSTANTS from "../../../util/constant/CONSTANTS";
import Devices from "./tabs/devices";
import AllErrorLog from "./tabs/AllErrorLog";
import BackButton from "../../../component/common/Back-Button";
import { useNavigate } from "react-router-dom";
import { role } from "../../../util/Route";

const DeviceType = () => {
    const menus = {
        type: <Devices />,
        error: <AllErrorLog />,
    };
    const navigate = useNavigate()
    return (
        <>
            <div >

                <Card className="mt-5">
                    {role === 'Admin' && <BackButton onClick={() => navigate(-1)} />}
                    <Tabs
                        className="p-0 m-0"
                        defaultActiveKey="1"
                        size="middle"
                        type="card"
                        items={CONSTANTS.TAB_MENU.DEVICES.map((ele) => {
                            if (ele.Role?.includes(role)) {
                                return {
                                    label: `${ele.Label}`,
                                    key: `${ele.id}`,
                                    children: menus[ele?.id],
                                };
                            }
                        })}
                    />
                </Card>
            </div>
        </>
    );
};

export default DeviceType;
